import axios from "axios";

const api = axios.create({
    // baseURL: "https://api.synergytoss.net/api/v1/",
     baseURL: "https://api.synergytoss.net/api/v1/",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Cache-Control": "no-cache",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem("tos-token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            sessionStorage.removeItem("toss-token"); // Remove expired token
            window.location.href = "/login"; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default api;
